import { render, staticRenderFns } from "./DetailColumnToolPanel.vue?vue&type=template&id=0fdede9b&scoped=true&"
import script from "./DetailColumnToolPanel.vue?vue&type=script&lang=js&"
export * from "./DetailColumnToolPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdede9b",
  null
  
)

export default component.exports